import React, { useState } from 'react';
import { Menu, X, Settings } from 'lucide-react';
import { useData } from '../context/DataContext';

const Navbar = ({ activeTab, setActiveTab }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { projectInfo, loading } = useData();

  const navLinks = [
    { id: 'home', name: 'Home' },
    { id: 'about', name: 'About' },
    { id: 'partners', name: 'Partners' },
    { id: 'activities', name: 'Activities' },
    { id: 'resources', name: 'Resources' },
    { id: 'impact', name: 'Impact' },
  ];

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
    setIsOpen(false);
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white shadow-md">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <button
            onClick={() => handleTabClick('home')}
            className="flex items-center gap-3 group"
          >
            {!loading && projectInfo && (
              <>
                <img
                  src={projectInfo.logo}
                  alt="Project Logo"
                  className="h-14 w-14 object-contain transition-transform duration-300 group-hover:scale-105"
                />
                <div className="hidden sm:block">
                  <p className="font-bold text-sm tracking-wide text-[#1e3a5f]">
                    {projectInfo.name}
                  </p>
                  <p className="text-xs text-[#3d6a99]">
                    Erasmus+ KA2
                  </p>
                </div>
              </>
            )}
          </button>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-1">
            {navLinks.map((link) => (
              <button
                key={link.id}
                onClick={() => handleTabClick(link.id)}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-300 ${
                  activeTab === link.id
                    ? 'bg-[#1e3a5f] text-white'
                    : 'text-[#1e3a5f] hover:bg-[#1e3a5f]/10'
                }`}
              >
                {link.name}
              </button>
            ))}
            {/* Admin Button */}
            <button
              onClick={() => handleTabClick('admin')}
              className={`ml-2 p-2 rounded-lg transition-all duration-300 ${
                activeTab === 'admin'
                  ? 'bg-[#1e3a5f] text-white'
                  : 'text-gray-400 hover:text-[#1e3a5f] hover:bg-[#1e3a5f]/10'
              }`}
              title="Admin Panel"
            >
              <Settings className="w-5 h-5" />
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="lg:hidden p-2 rounded-lg text-[#1e3a5f] hover:bg-[#1e3a5f]/10 transition-colors duration-300"
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        <div
          className={`lg:hidden overflow-hidden transition-all duration-300 ${
            isOpen ? 'max-h-[500px] pb-4' : 'max-h-0'
          }`}
        >
          <div className="bg-[#f8fafc] rounded-xl p-4 space-y-1">
            {navLinks.map((link) => (
              <button
                key={link.id}
                onClick={() => handleTabClick(link.id)}
                className={`block w-full text-left px-4 py-3 rounded-lg font-medium transition-colors duration-300 ${
                  activeTab === link.id
                    ? 'bg-[#1e3a5f] text-white'
                    : 'text-[#1e3a5f] hover:bg-[#1e3a5f]/10'
                }`}
              >
                {link.name}
              </button>
            ))}
            <button
              onClick={() => handleTabClick('admin')}
              className={`block w-full text-left px-4 py-3 rounded-lg font-medium transition-colors duration-300 ${
                activeTab === 'admin'
                  ? 'bg-[#1e3a5f] text-white'
                  : 'text-gray-400 hover:bg-[#1e3a5f]/10'
              }`}
            >
              <Settings className="w-4 h-4 inline mr-2" />
              Admin Panel
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
